import React, { useState } from 'react'
import Carousel from "react-spring-3d-carousel";
import { v4 as uuidv4 } from "uuid";
import { config } from "react-spring";
import sudhaar from '../assets/Initiatives/poshan.jpeg';
import gyaan from '../assets/Initiatives/medicalcamp.jpeg';
import nirmaan from '../assets/Initiatives/annualmeet.jpeg';
import gogreen from '../assets/Initiatives/rojgarmela.jpeg';
import muskaan from '../assets/Initiatives/vikas.jpeg';
import train from '../assets/Initiatives/training.jpeg';
import manrega from '../assets/Initiatives/rally.jpeg';
import cdo from '../assets/Initiatives/cdo.jpeg';
import aware from '../assets/Initiatives/aware.jpeg';
import aware2 from '../assets/Initiatives/awarenes.jpeg';
import poshan2 from '../assets/Initiatives/poshan2.jpeg';
import '../css/initiatives.css';

const Initiatives = () => {
  const isMobile = window.innerWidth <= 768;
  const [card, setCard] = useState({
    goToSlide: 0,
    offsetRadius: 2,
    showNavigation: true,
    config: config.slow
  });

  const InCards = [

    {
    key: uuidv4(),
    content: <img src={nirmaan} alt="Nirmaan" />,
    link: "",
    description: "स्वयं सहायता समूह की महिलाओं के साथ वार्षिक अधिवेशन में उड़ान सेवा ट्रस्ट की अध्यक्ष मीनू चौबे"
  },
  {
    key: uuidv4(),
    content: <img src={train} alt="Train" />,
    link: "",
    description: "उड़ान सेवा ट्रस्ट के सौजन्य से महिलाओं को अगरबत्ती का प्रशिक्षण देकर प्रमाण पत्र वितरण करते हैं"
  },
    {
    key: uuidv4(),
    content: <img src={sudhaar} alt="Sudhaar" />,
    link: "",
    description: "कुपोषण से सुपोषण की ओर डाला  के विभिन्न क्षेत्रों में पोषण किट वितरण"
  },
  {
    key: uuidv4(),
    content: <img src={gyaan} alt="Gyaan" />,
    link: "",
    description: "उड़ान सेवा ट्रस्ट के सौजन्य से निशुल्क मेडिकल कैंप लगवाते हुए मारकुंडी पंचायत भवन "
  },
  
  {
    key: uuidv4(),
    content: <img src={gogreen} alt="Go Green" />,
    link: "",
    description: "सोनभद्र में आयोजित रोजगार मेले में कौशल विकास ट्रेनिंग के उपरांत बच्चों को प्रतिभा करवाते हुए"
  },
  {
    key: uuidv4(),
    content: <img src={muskaan} alt="Muskaan" />,
    link: "",
    description: "उड़ान सेवा ट्रस्ट के सौजन्य से कौशल विकास कार्यक्रम का आयोजन किया गया बच्चों को प्रमाण पत्र वितरण करते हुए"
  },
  {
    key: uuidv4(),
    content: <img src={manrega} alt="Manrega" />,
    link: "",
    description: "मनरेगा में काम करने के लिए जागरूकता अभियान चलाया गया"
  },
  {
    key: uuidv4(),
    content: <img src={cdo} alt="cdo" />,
    link: "",
    description: "कुपोषित बच्चों को पोषण किट वितरण हेतु जिला मुख्य विकास अधिकारी का मार्गदर्शन प्राप्त हुआ"
  },
   {
    key: uuidv4(),
    content: <img src={aware} alt="aware" />,
    link: "",
    description: "उड़ान सेवा ट्रस्ट के सौजन्य से मिशन शक्ति अभियान चलाते हुए"
  },
   {
    key: uuidv4(),
    content: <img src={aware2} alt="aware2" />,
    link: "",
    description: "उड़ान सेवा ट्रस्ट के सौजन्य से स्वच्छता पर जागरूकता अभियान चलाते हुए"
  },
  {
    key: uuidv4(),
    content: <img src={poshan2} alt="poshan2" />,
    link: "",
    description: "कुपोषण से सुपोषण की ओर, विभिन्न क्षेत्रों में पोषण किट वितरण करते हुए"
  },

  ].map((slide, index) => {
    return {
      ...slide,
      onClick: () => {
        if (index === card.goToSlide)
          window.open(slide.link);
        setCard({ ...card, goToSlide: index })
      }
    }
  });

  const onRight = () => {
   setCard({
    ...card,
    goToSlide: (card.goToSlide + 1) % InCards.length
  });
  }

  const onLeft = () => {
   setCard({
    ...card,
    goToSlide:
      card.goToSlide === 0
        ? InCards.length - 1
        : card.goToSlide - 1
  });
  }

  return (
    <div className="Initiatives">
      <br />
      <br />
      <div className="title">
        <h1><span>OUR</span> INITIATIVES</h1>
      </div>
      <div className="initiative-cards">
        <Carousel
          slides={InCards}
          goToSlide={card.goToSlide}
          offsetRadius={card.offsetRadius}
          showNavigation={card.showNavigation}
          animationConfig={card.config}
        />
      </div>
       <p className="initiative-note">
  {InCards[card.goToSlide]?.description}
</p>

      <div className="arrows">
        <svg onClick={onLeft} xmlns="http://www.w3.org/2000/svg" width={isMobile?"30":"40"} height={isMobile?"30":"40"} fill="currentColor" className="leftarr bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
          <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
        </svg>
        <svg onClick={onRight} xmlns="http://www.w3.org/2000/svg" width={isMobile?"30":"40"}  height={isMobile?"30":"40"}  fill="currentColor" className="rightarr bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
          <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
        </svg>
      </div>
    </div>
  )
}


export default Initiatives
